import { AfterViewInit, ChangeDetectionStrategy, Component, QueryList, ViewChildren } from '@angular/core';
import { Subject, map, startWith, takeUntil } from 'rxjs';
import { ActorAuthComponent } from '../actor-auth/actor-auth.component';
import { ActorAuthChecklistService } from './actor-auth.checklist.service';
@Component({
  selector: 'ss-actor-auth-checklist',
  templateUrl: './actor-auth.checklist.component.html',
  styleUrls: ['./actor-auth.checklist.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActorAuthChecklistComponent implements AfterViewInit {

  @ViewChildren(ActorAuthComponent)
  private _actorAuthsQL: QueryList<ActorAuthComponent>

  readonly actorAuthDefs = this._actorAuthChecklistService.actorAuthDefs;
  readonly actorAuthComponentsSubject = this._actorAuthChecklistService.actorAuthComponentsSubject;
  constructor(
    private readonly _actorAuthChecklistService: ActorAuthChecklistService
  ) { }

  ngAfterViewInit(): void {

    this._actorAuthsQL.changes
      .pipe(
        startWith(this._actorAuthsQL),
        map((actorAuthsQL: QueryList<ActorAuthComponent>) => actorAuthsQL.toArray()),
        takeUntil(this._destroy)
      )
      .subscribe((actorAuths) => {
        this.actorAuthComponentsSubject.next(actorAuths);
      })
  }

  private readonly _destroy = new Subject<void>()

  ngOnDestroy() {
    this._destroy.next()
    this._destroy.complete()
  }
}
